module.exports = __webpack_public_path__ + "img/kinsho.bed3c06e.png";